// 审批管理
export default {
  path: '/approval',
  component: () => import('@/layout/Empty.vue'),
  children: [
    {
      path: '',
      component: () => import('@/views/user/approve/ApproveList.vue'),
      redirect: 'approval-unaccomplished',
      children: [
        {
          path: 'approval-unaccomplished',
          component: () => import('@/views/user/approve/ApprovalUnaccomplished.vue')
        },
        {
          path: 'approval-pass',
          component: () => import('@/views/user/approve/ApprovalPass.vue')
        },
        {
          path: 'approval-reject',
          component: () => import('@/views/user/approve/ApprovalReject.vue')
        },
        {
          path: 'approval-cancle',
          component: () => import('@/views/user/approve/ApprovalCancle.vue')
        },
        {
          path: 'approval-all',
          component: () => import('@/views/user/approve/ApprovalAll.vue')
        }
      ]
    },
    {
      path: 'apply-signature-detail',
      component: () => import('@/views/user/approve/ApplySignatureDetail')
    },
    // {
    //   path: 'contract/:approvalStaffId',
    //   name: 'contractApprove',
    //   component: () => import('@/views/user/contract/ContractDetail.vue'),
    //   props: true,
    //   meta: {
    //     title: '审批详情',
    //     layout: {
    //       pageBack: true
    //     },
    //     personVerify: true
    //   }
    // },
    {
      path: 'contract/preview',
      name: 'contractApprovePreview',
      component: () => import('@/views/user/contract/ContractPreview.vue'),
      props: true,
      meta: {
        title: '合同预览', // 审批详情
        layout: {
          subPage: true,
          pageWrap: false
        }
      }
    }
  ]
}
